import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import * as Pages from 'pages';
import { constants } from 'utils';

const disableBorderPermits = (process.env.REACT_APP_DISABLE_BORDER_PERMITS || '').trim() === 'true';

export default function Routes() {
  const maintenanceMode = window.ENV?.maintenanceMode;
  return (
    <Switch>
      <Redirect exact from={constants.Routes.Root} to={constants.Routes.Home} />
      <Route exact path={constants.Routes.Home}>
        {maintenanceMode ? <Pages.Maintenance /> : <Pages.Home />}
      </Route>
      {!disableBorderPermits && !maintenanceMode && (
        <Route exact path={constants.Routes.Transaction}>
          <Pages.Transaction />
        </Route>
      )}
      <Route exact path={constants.Routes.TechnicalError}>
        <Pages.TechnicalError />
      </Route>
      <Route path={constants.Routes.Others}>
        <Pages.NoMatch />
      </Route>
    </Switch>
  );
}
